import '@hotmart/cosmos/dist/tooltip'
import { useGoogleAnalytics } from '@hotmart/space-lib/dist/hooks'
import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import i18n from 'src/i18n'
import { useUser } from 'src/hook/useUser'
import useSendDatahubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { CommentSuggestionProps, HandleClickParams } from './commentSuggestion.types'
import { getDefaultSuggestions } from './utils'
import {
  CommentSuggestionOption,
  CommentSuggestionOptions,
  Wrapper
} from './commentSuggestion.styles'

const CommentSuggestion = ({ onClick }: CommentSuggestionProps) => {
  const { user, locale } = useUser()
  const { sendDataHubConsume } = useSendDatahubConsume()
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics({
    userId: user?.id,
    locale
  })

  const suggestions = getDefaultSuggestions(i18n)

  const handleClick = ({ comment, option }: HandleClickParams) => {
    onClick(comment)

    sendDataHubConsume({
      action: Actions.VIEW,
      entity: Entities.COMMUNITY,
      event: {
        eventName: EventNames.CLICK_SUGGESTED_COMMENT,
        screenName: ScreenNames.COMMUNITY_FEED,
        componentName: ComponentNames.COMMUNITY_FEED,
        option
      }
    })

    sendGoogleAnalyticsEvent({
      group: Entities.GENERIC,
      name: Actions.CREATE,
      label: option
    })
  }

  return (
    <Wrapper
      className="_d-flex _justify-content-center _flex-column _text-2 _pt-3 _justify-content-md-start _flex-md-row"
      data-test="comment-suggestion"
    >
      <CommentSuggestionOptions className="_d-flex _flex-column _flex-sm-row">
        {suggestions.map(({ comment, option }) => (
          <CommentSuggestionOption
            key={comment}
            className="_text-1 _text-gray-600 _d-flex _justify-content-center _align-items-center _px-3 _py-1 _border _border-gray-200 _rounded-pill _cursor-pointer"
            onClick={() => handleClick({ comment, option })}
          >
            {comment}
          </CommentSuggestionOption>
        ))}
      </CommentSuggestionOptions>
    </Wrapper>
  )
}

export default CommentSuggestion
